import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Landmark, Sprout, Target, ShieldCheck, Droplets, Tractor, Coffee, Microscope, Activity, Bug } from 'lucide-react';
const programs = [{
  title: 'NAADS',
  desc: 'National Agricultural Advisory Services: Increasing agricultural production and productivity, market access, and value addition.',
  icon: Sprout,
  color: 'border-uganda-green',
  link: '/agencies'
}, {
  title: 'UCDA',
  desc: 'Uganda Coffee Development Authority: Promoting and overseeing the coffee industry in Uganda to ensure quality and market competitiveness.',
  icon: Coffee,
  color: 'border-amber-700',
  link: '/agencies'
}, {
  title: 'NARO',
  desc: 'National Agricultural Research Organisation: Driving agricultural research and technology development for sustainable farming.',
  icon: Microscope,
  color: 'border-blue-500',
  link: '/agencies'
}, {
  title: 'DDA',
  desc: 'Dairy Development Authority: Developing the dairy industry and ensuring quality dairy products across the nation.',
  icon: Activity,
  color: 'border-sky-400',
  link: '/agencies'
}, {
  title: 'NAGRC&DB',
  desc: 'National Animal Genetic Resources Centre & Data Bank: Conservation and management of animal genetic resources.',
  icon: ShieldCheck,
  color: 'border-purple-500',
  link: '/agencies'
}, {
  title: 'COCTU & CDOUGA',
  desc: 'Development of cotton, coffee, tea, and tobacco sub-sectors, and control of trypanosomiasis (sleeping sickness) in Uganda.',
  icon: Bug,
  color: 'border-uganda-red',
  link: '/agencies'
}];
export function ProgramsSection() {
  return <section className="py-16 bg-uganda-gray" data-id="element-356">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-357">
        <div className="flex justify-between items-end mb-10" data-id="element-358">
          <div data-id="element-359">
            <h2 className="text-3xl font-bold text-uganda-black mb-4" data-id="element-360">
              Ministry Agencies
            </h2>
            <p className="text-gray-600 max-w-2xl" data-id="element-361">
              Discover the seven semi-autonomous agencies driving agricultural
              transformation, research, and development across Uganda.
            </p>
          </div>
          <Link to="/agencies" className="hidden md:flex items-center text-uganda-green font-semibold hover:text-green-800 transition-colors" data-id="element-362">
            View All Agencies <ArrowRight className="w-5 h-5 ml-2" data-id="element-363" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-364">
          {programs.map((program, index) => {
          const Icon = program.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all border-t-4 ${program.color} border-x border-b border-gray-100 flex flex-col h-full`} data-id="element-365">
                <div className="w-12 h-12 rounded-full bg-gray-50 flex items-center justify-center text-gray-700 mb-4" data-id="element-366">
                  <Icon className="w-6 h-6" data-id="element-367" />
                </div>
                <h3 className="text-xl font-bold text-uganda-black mb-3" data-id="element-368">
                  {program.title}
                </h3>
                <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-369">
                  {program.desc}
                </p>
                <Link to={program.link} className="inline-flex items-center text-sm font-semibold text-uganda-green hover:text-green-800 transition-colors mt-auto" data-id="element-370">
                  Learn More <ArrowRight className="w-4 h-4 ml-1" data-id="element-371" />
                </Link>
              </motion.div>;
        })}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-372">
          <Link to="/agencies" className="inline-block bg-white border border-gray-200 text-uganda-black px-6 py-3 rounded-md font-semibold w-full" data-id="element-373">
            View All Agencies
          </Link>
        </div>
      </div>
    </section>;
}